import { IQuickFilter } from "../../../interfaces/common/quick-filters";
import { quickFiltersToFilterOptions } from "../../../utils/quick-filters";
import { IFilterOption } from "../filter-bar/types";

export const ApplyQuickFilter = (quickFilter: IQuickFilter | null, currentFilters: IFilterOption[], setFilters: (filters: IFilterOption[]) => void) => {
    console.log('called liio: ', currentFilters.map(p => p.toLabel()), " || ", quickFilter)
    setFilters([...currentFilters.filter(f => !f.isQuickFilter()), ...quickFiltersToFilterOptions(quickFilter)]);
}

export const UnapplyQuickFilter = (currentFilters: IFilterOption[], setFilters: (filters: IFilterOption[]) => void) => {
    setFilters(currentFilters.filter(f => !f.isQuickFilter()));
}